//// Safee App Module const
export const PROCESS_SAFEE_DOWNLOAD_EWD_EVENT = 'processSafeeDownloadEWDEvent';
export const DOWNLOAD_EWD = 'downloadEWD';
export const DOWNLOAD_UNLIMITED_EWD = 'downloadUnlimitedEWD';
export const RESEND_ACTIVE_LINK = 'resendActiveLink';
export const PROCESS_SAFEE_DOWNLOAD_FORM_EVENT = 'processSafeeDownloadFormEvent';
export const DOWNLOAD_FORM = 'downloadForm';
